<template>
    <div class='swiperBg' :style="'padding: 0 ' + item.lrConfig.val + 'px;padding-top:' + item.mbConfig.val +'px;' + 'background-image: linear-gradient(to bottom, ' + item.bgColor.color[0].item + ', ' + item.bgColor.color[1].item + ');'">
        <div class='swiperBox' :class="{'border-radius': item.bgStyle.type === 1}">
            <img v-if='item.swiperConfig.list.length != 0 &&  item.swiperConfig.list[0].img != ""' class='swiper-image' :src='item.swiperConfig.list[0].img'/>
            <div v-else class='noImageUrl'>
                <i class='el-icon-picture'></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'swiperBg',
    props:{
        item:{
            type:Object,
            default: {}
        }
    },
    data() {
        return {

        };
    }
};
</script>

<style lang='scss' scoped>
    .swiperBox{
        width: 100%;
        height: 100%;
        overflow: hidden;
        .swiper-image{
            max-width: 100%;
            object-fit: contain;
        }
        .noImageUrl{
            width: 100%;
            height: 147px;
            background-color: #f3f5f7;
            color: #bbbfc8;
            font-size: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .border-radius{
        border-radius: 6px;
        overflow: hidden;
    }
</style>